import { render } from "./pay-finish.vue?vue&type=template&id=234dfaeb&scoped=true"
import script from "./pay-finish.vue?vue&type=script&lang=js"
export * from "./pay-finish.vue?vue&type=script&lang=js"

import "./pay-finish.vue?vue&type=style&index=0&id=234dfaeb&scoped=true&lang=scss"

import exportComponent from "E:\\my-work\\company\\product\\yuanxi\\yuanxi-zju\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-234dfaeb"]])

export default __exports__